var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("VueGoodTable", {
        ref: "table",
        attrs: {
          columns: _vm.columns,
          "pagination-options": _vm.paginationOptions,
          "search-options": _vm.searchOptions,
          "select-options": _vm.selectConfig,
          mode: "remote",
          rows: _vm.vgtManager.results.data,
          totalRows: _vm.vgtManager.results.totalRows,
          isLoading: _vm.vgtManager.isLoading
        },
        on: {
          "on-row-click": _vm.onClick,
          "on-page-change": function($event) {
            _vm.vgtManager.pageEvent.bind(_vm.vgtManager)($event)
          },
          "on-sort-change": function($event) {
            _vm.vgtManager.sortEvent.bind(_vm.vgtManager)($event)
          },
          "on-column-filter": function($event) {
            _vm.vgtManager.filterEvent.bind(_vm.vgtManager)($event)
          },
          "on-per-page-change": function($event) {
            _vm.vgtManager.perPageEvent.bind(_vm.vgtManager)($event)
          },
          "on-search": function($event) {
            _vm.vgtManager.searchEvent.bind(_vm.vgtManager)($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "actions"
                  ? _c(
                      "div",
                      {
                        staticClass: "btn-group",
                        attrs: { role: "group", "aria-label": "Basic example" }
                      },
                      [
                        _vm.editable
                          ? [
                              _vm.windowArchive
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-danger btn-sm",
                                      attrs: {
                                        title: _vm.$t("testEquipmentArchive")
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          $event.stopPropagation()
                                          return _vm.onArchive(props.row)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-trash-alt"
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.windowAudit
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-success btn-sm",
                                      attrs: {
                                        title: _vm.$t("testEquipmentAddTest")
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          $event.stopPropagation()
                                          return _vm.onAddTest(props.row)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fas fa-plus" })]
                                  )
                                : _vm._e()
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : props.column.field === "measurementSpecifications"
                  ? _c("MeasurementSpecificationsTemplateBadges", {
                      attrs: {
                        measurementSpecifications:
                          props.row.measurementSpecifications
                      }
                    })
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n      "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("TestEquipmentEditModal", {
        ref: "equipmentModal",
        attrs: {
          editable: _vm.editable && _vm.windowEdit,
          showArchiveFields: _vm.showArchiveFields
        },
        on: { save: _vm.save, "file-added": _vm.equipmentFileAdded }
      }),
      _vm._v(" "),
      _c("TestEquipmentTestEditModal", {
        ref: "testModal",
        attrs: { editable: _vm.editable && _vm.windowEdit }
      }),
      _vm._v(" "),
      _c("ArchiveModal", {
        ref: "archivemodal",
        on: { archive: _vm.onArchiveConfirm }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "float-right" }, [
        _vm.canUpload
          ? _c(
              "button",
              {
                staticClass: "btn btn-info mt-2 ml-1",
                attrs: { type: "button" },
                on: { click: _vm.openImportModal }
              },
              [
                _c("i", { staticClass: "fas fa-exchange-alt" }),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("testEquipment.main.teBtnUpload")) +
                    "\n    "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary mt-2 ml-1",
            attrs: { type: "button" },
            on: { click: _vm.exportCSV }
          },
          [_vm._v("\n      CSV Export\n    ")]
        ),
        _vm._v(" "),
        _vm.editable && _vm.windowEdit
          ? _c(
              "button",
              {
                staticClass: "btn btn-success mt-2 ml-1",
                attrs: { type: "button" },
                on: { click: _vm.createNew }
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("btnAdd")) + "\n    ")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("TeImportModal", {
        ref: "importModal",
        on: {
          imported: function($event) {
            return _vm.state.devicesStore.reload()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }